import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, ListChecks, GitCompare, FileSpreadsheet, Users, LogOut, BarChart3 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/admin/submissions", label: "Submissions", icon: ListChecks },
  { to: "/admin/compare", label: "Compare", icon: GitCompare },
  { to: "/admin/workbooks", label: "Workbooks", icon: FileSpreadsheet },
  { to: "/admin/admins", label: "Administrators", icon: Users },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => { await logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen flex bg-alabaster">
      <aside className="w-64 shrink-0 bg-oxford text-white flex flex-col fixed h-screen">
        <div className="p-6 border-b border-white/10">
          <div className="font-serif text-2xl tracking-tight">Aikyam</div>
          <div className="overline text-white/40 mt-1">Admin Console</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-sm text-sm transition-colors ${
                  isActive ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"
                }`}>
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="px-4 py-2">
            <div className="text-sm text-white truncate">{user?.name || "Admin"}</div>
            <div className="text-xs text-white/50 truncate">{user?.email}</div>
          </div>
          <button data-testid="logout-btn" onClick={doLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-sm text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 min-h-screen">
        <div className="max-w-6xl mx-auto px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
